import { render, staticRenderFns } from "./CenterHeader.vue?vue&type=template&id=76d1899e&scoped=true&"
import script from "./CenterHeader.vue?vue&type=script&lang=ts&"
export * from "./CenterHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CenterHeader.vue?vue&type=style&index=0&id=76d1899e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d1899e",
  null
  
)

export default component.exports